const playlistsNav=[
  {
    id:1,
    name:"Vessel",
    href:"#"
},
{
  id:2,
  name:"Hollywood's Bleeding",
  href:"#"
},
{
  id:3,
  name:"Blurryface",
  href:"#"
},
{
  id:4,
  name:"Trench",
  href:"#"
},
{
  id:5,
  name:"Twelve Carat Tootache",
  href:"#"
},
{
  id:6,
  name:"Two Hearts Never Break The Same",
  href:"#"
},
{
  id:7,
  name:"Not By Chance",
  href:"#"
},
{
id:8,
name:"Melophobia",
href:"#"
},
{
id:9,
name:"Dreamland",
href:"#"
},
{
id:10,
name:"Pray For The Wicked",
href:"#"
},
{
id:11,
name:"After Hours",
href:"#"
},
{
id:12,
name:"Certified Lover Boy",
href:"#"
},
{
  id:13,
  name:"Dawn FM",
  href:"#"
},
{
id:14,
name:"Death Race For Love",
href:"#"
},
{
id:15,
name:"Perception",
href:"#"
},
{
id:16,
name:"The Search",
href:"#"
},
{
id:17,
name:"The College Dropout",
href:"#"
},
{
id:18,
name:"Music To Be Murdered By",
href:"#"
},
{
id:19,
name:"Relapse: Refill",
href:"#"
},
{
id:20,
name:"The Slim Shady LP",
href:"#"
},
{
  id:21,
  name:"Dawn FM",
  href:"#"
},
{
id:22,
name:"Death Race For Love",
href:"#"
},
{
id:23,
name:"Perception",
href:"#"
},
{
id:24,
name:"The Search",
href:"#"
}

];
export default playlistsNav;